export default __webpack_public_path__ + "locales/el-GR/SocialAuthWelcomeDialog.json?hash=d8c64b5c593c3c90123ed6f058ad9d13";